export default "__VITE_ASSET__9e0125a6__"